import { useCallback } from 'react';
import { useApplicationOperations } from 'entities/application';
import { useRouteContext } from 'pages/Map/context/route';
import { useGetStationByCode } from 'store/features/stations';
import usePermissions from 'common/hooks/usePermissions';
import { useSelectedFavouriteStationContext } from '../context';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';
import { MODALS } from 'entities/application';

export const useHandleSetRoutePoint = () => {
  const { setStationRoutePoint } = useRouteContext();
  const { selectedFavouriteStation } = useSelectedFavouriteStationContext();
  const getStationByCode = useGetStationByCode();
  const { setActiveMenuItem, addActiveModal, deleteActiveModal } = useApplicationOperations();
  const permission = usePermissions();

  const handleSetStationRoutePoint = useCallback(() => {
    if (!permission.locatorProAccess) {
      addActiveModal(MODALS.tariffInfoModal);
      return;
    }

    if (selectedFavouriteStation) {
      const station = getStationByCode(selectedFavouriteStation.stationCode);

      if (station) {
        setStationRoutePoint(station);
        setActiveMenuItem('route');
        deleteActiveModal(MODALS.favouriteStations);
      }

      logAmplitudeEvent(STATIONS_AMPLITUDE_EVENTS.buildRouteThroughFavouriteServicePoint, { extra: { stationCode: station.code } })
    }
  }, [
    setStationRoutePoint,
    selectedFavouriteStation,
    getStationByCode,
    setActiveMenuItem,
    deleteActiveModal,
    permission,
    addActiveModal
  ]);

  return handleSetStationRoutePoint;
};
